import { NativeDateAdapter } from '@angular/material/core';
import * as moment from 'moment/moment';
import { Injectable } from "@angular/core";

@Injectable()
export class CustomDateAdapter extends NativeDateAdapter {
  parse(value: any): Date {
    return moment(value, 'DD/MM/YYYY').toDate();
  }
}
